import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { NewsCard } from "~/components/NewsCard/NewsCard"
import { Raw } from "~/components/raw"
import { ScrollSnap } from "~/components/ScrollSnap/ScrollSnap"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

export const News: React.FC = () => {
  const { t } = useTranslation()
  const { otherNews } = useApiContext("/sustainable/page")

  if (otherNews.length === 0) {
    return null
  }

  return (
    <Wrapper>
      <div className="container">
        <div className={styles.Head}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("sustainable-development.News.Title")} />
          </Heading>

          <Link href="/press?tags_arr=66231" view="arrow">
            <Raw html={t("sustainable-development.OtherNews.Link")} />
          </Link>
        </div>

        <ScrollSnap className={styles.Cards} maxSize="md">
          {otherNews.slice(0, 4).map((item, i) => (
            <NewsCard {...item} key={i} />
          ))}
        </ScrollSnap>
      </div>
    </Wrapper>
  )
}
